/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaperClipIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaperClipIcon({
  children,
  viewPath = "/DesignSystem/Svgs/PaperClipIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="PaperClipIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-18qdSb': alignSelf,'--mt-2-18qdSb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-18qdSb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-18qdSb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-18qdSb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-18qdSb': opacity,'--w-10-18qdSb': typeof width === 'number' ? `${width}px` : width,'--h-11-18qdSb': typeof height === 'number' ? `${height}px` : height,'--a-7-18qdSb': isAnimated ? animation : "none",'--sd-8-18qdSb': isAnimated ? strokeDashoffset : 0,'--sd-9-18qdSb': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="PaperClipIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M11 23.5l11.2-11.2c.9-.9.9-2.5 0-3.4h0c-.9-.9-2.5-.9-3.4 0L15 12.7l-3 3-4.9 4.9c-1.9 1.9-1.9 4.9 0 6.8h0c1.9 1.9 4.9 1.9 6.8 0l5.8-5.8 2.2-2.2 3.8-3.8c2.8-2.8 2.8-7.4 0-10.2h0c-2.8-2.8-7.4-2.8-10.2 0L4.1 16.7"
 style={{'--f-12-18qdSb': fill,'--s-13-18qdSb': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}